<template>
  <v-card>
    <v-app-bar app dark class="d-md-none d-lg-none d-xl-none btnSubmit">
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon class="d-md-none d-lg-none d-xl-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-navigation-drawer v-model="drawer" absolute temporary right clipped app fixed class="d-md-none d-lg-none d-xl-none">
        <v-list-item>
          <v-spacer></v-spacer>
          <v-icon @click.stop="drawer = !drawer">mdi-close</v-icon>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense>
          <v-list-item v-for="item in items" :key="item.title" link>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <router-link style="text-decoration: none; color: inherit" :to="item.route">
                  {{ item.title }}
                </router-link>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-app-bar>
  </v-card>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      drawer: null,
      items: [
        {
          title: "ออกจากระบบ",
          icon: "mdi-home-city",
          route: "/logoff",
        },
      ],
    };
  },
};
</script>

<style></style>
